export default {
  noWarning: () => true,
  freeTextMedical: (question) =>
    !(
      question.isTakingAnyMedicine != null &&
      question.isTakingAnyMedicine &&
      question.isTakingContraindicated != null &&
      !question.isTakingContraindicated &&
      (question.otherMedicinesTaken === null || question.otherMedicinesTaken === "")
    ),
  customFreeTextMedical(question) {
    return !(
      question.isResponseYes != null &&
      question.isResponseYes !== question.expectYes &&
      (question.freeTextResponse === null || question.freeTextResponse === "")
    );
  },
  multipleChoice(question) {
    if (question.response === null) {
      return true;
    }

    return question.response === (question.expectYes ? "Yes" : "No");
  },
  multiSelect(question) {
    const moreInfoOptions = question.options.filter((option) => option.moreInfo).map((option) => option.value);
    const needsMoreInfo = question.response.filter((response) => moreInfoOptions.indexOf(response) !== -1).length > 0;
    const freeTextFilledIn =
      question.freeTextResponse !== null && question.freeTextResponse !== undefined && question.freeTextResponse !== "";
    return !needsMoreInfo || freeTextFilledIn;
  },
  photoUpload: (question) => {
    return !!question?.responseImageKey;
  },
};
